module.exports = __webpack_public_path__ + "img/thank_you_small.13d40bee.png";